import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import urljoin from 'url-join';
import {
  AppInitViewModel,
  HomescreenAppInitViewModel,
  InstalledAppViewModel,
  InstallWebAssistantViewModel,
  UpdateWebAssistantViewModel,
  WebAssistantViewModel,
} from '../models';
import { AppConfigViewModel } from '@/features/apps/shared/models';

class WebAssistantApiService {
  private version = 'v1';

  public getInstalledApp(workspaceId: string): Promise<InstalledAppViewModel> {
    return api.send('GET', urljoin(config().webAssistantHost, this.version, `app?workspaceId=${workspaceId}`));
  }

  public installWebAssistant(request: InstallWebAssistantViewModel): Promise<InstalledAppViewModel> {
    return api.send('POST', urljoin(config().webAssistantHost, this.version, 'app', 'install'), request);
  }

  public updateWebAssistant(workspaceId: string, webAssistantConfig: WebAssistantViewModel) {
    const request = webAssistantConfig as UpdateWebAssistantViewModel;
    request.workspaceId = workspaceId;
    return api.send('POST', urljoin(config().webAssistantHost, this.version, 'app', 'update'), request);
  }

  public async homescreenAppInit(
    workspaceId: string,
    installedAppId: string,
    configData: any = {},
  ): Promise<HomescreenAppInitViewModel> {
    const request: AppInitViewModel = { appUserId: '', config: configData };
    const host = config().webAssistantHost;
    const url = urljoin(host, this.version, 'workspaces', workspaceId, 'apps', installedAppId, 'init');
    const response: any = await api.send('POST', url, request);
    if (typeof response.panel === 'string') {
      response.panel = {
        components: JSON.parse(response.panel),
        storedData: {},
      };
    }
    return response;
  }

  public async homescreenAppConfig(
    workspaceId: string,
    installedAppId: string,
    inputData: { [key: string]: string },
    storedData: { [key: string]: string },
    componentId?: string,
  ): Promise<AppConfigViewModel> {
    const request = {
      inputData,
      storedData,
      componentId,
    };
    const host = config().webAssistantHost;
    const url = urljoin(host, this.version, 'workspaces', workspaceId, 'apps', installedAppId, 'config');
    const response: any = await api.send('POST', url, request);
    if (typeof response.panel === 'string') {
      response.panel = {
        components: JSON.parse(response.panel),
        storedData: {},
      };
    }
    return response;
  }
}

export const webAssistantApi = new WebAssistantApiService();
